export default [
    {
        name: 'base',
        data: {},
        items:
        [
            { name: 'dummy', source: '../images/8bit_cursor-32.png', type: 'image' },
        ]
    }
]